import React, { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { PropTypes } from 'prop-types';

AudioViewer.propTypes = {
  preview: PropTypes.any,
};

export default function AudioViewer({ preview }) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  const [options, setOptions] = useState({
    autoplay: true,
    controls: true,
    fluid: true,
    height: 450,
    poster: preview?.thumbnail?.fileUrl,
    audioPosterMode: true,
    playbackRates: [0.5, 1, 1.5, 2],
    sources: preview?.audioFiles?.map((audio) => ({
      src: audio.fileUrl,
      type: audio.mimeType
    }))
  });

  useEffect(() => {
    setOptions({
      autoplay: true,
      controls: true,
      fluid: true,
      height: 450,
      poster: preview?.thumbnail?.fileUrl,
      audioPosterMode: true,
      playbackRates: [0.5, 1, 1.5, 2],
      sources: preview?.videos?.map((video) => ({
        src: video.fileUrl,
        type: video.mimeType
      }))
    });
  }, [preview])

  useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement("video-js");
      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current.appendChild(videoElement);
      playerRef.current = videojs(videoElement, options, () => { });
    } else {
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options, videoRef]);

  useEffect(() => {
    const player = playerRef.current;
    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  let el = document.getElementById("vjs_video_3");
  if (el) el.style.height = "450px";
  el = document.getElementById("vjs_video_3_html5_api");
  if (el) el.style.height = "450px";

  return (
    <div data-vjs-player style={{ height: '450px' }}>
      <div ref={videoRef} style={{ height: '450px' }}/>
    </div>
  );
}